/* eslint-disable import/no-cycle */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Anchor, Breadcrumbs, ScrollArea } from '@mantine/core';
import { Link } from 'react-router-dom';
import AppStack from '../../../../common/AppStack';
import WsSectionContainer from '../WsSectionContainer';
import { getBreadcrumbsData } from '../../../../../helpers/webstoreHelper';

const WsBreadcrumbs = ({
  blocks,
  config,
  themeConfig,
  colorSchemes,
  mediaQueries,
  pathname,
  ecomStoreTheme,
  resourceNavigation,
  baseStoreUrl,
  onNavigate,
  ...rest
}) => {
  const scrollRef = React.useRef(null);
  const { isTabletOrSmaller } = mediaQueries;
  const colorScheme = colorSchemes[config.colorScheme - 1] ?? colorSchemes[0];
  const breadcrumbsData = getBreadcrumbsData(
    resourceNavigation,
    ecomStoreTheme
  );
  const isHidden =
    (config.hideSinglePage === 'true' && breadcrumbsData.length === 1) ||
    (config.hideOnMobile === 'true' && isTabletOrSmaller) ||
    breadcrumbsData.length === 0;
  const shortenLongTitles = config.shortenLongTitles === 'true';
  const maxTitleLength = config.shortenLongTitleLength * 1 || 300;

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollLeft = scrollRef.current.scrollWidth;
    }
  }, [breadcrumbsData, scrollRef.current]);

  return (
    !isHidden && (
      <WsSectionContainer
        colorScheme={colorScheme}
        config={config}
        mediaQueries={mediaQueries}
        themeConfig={themeConfig}
        withPadding
        {...rest}
      >
        <AppStack mx="auto" style={{ width: '100%' }}>
          {isTabletOrSmaller ? (
            <ScrollArea
              offsetScrollbars
              scrollbarSize={6}
              styles={{
                viewport: {
                  maxWidth: '100%',
                  overflowX: 'auto',
                  whiteSpace: 'nowrap'
                }
              }}
              type="scroll"
              viewportRef={scrollRef}
            >
              <Breadcrumbs
                separator={
                  config.separator === 'custom'
                    ? config.customSeparator || '/'
                    : config.separator
                }
                styles={{ root: { flexWrap: 'nowrap' } }}
              >
                {breadcrumbsData.map((n) => (
                  <Anchor
                    key={n.title + n.path}
                    component={Link}
                    onClick={onNavigate}
                    styles={{
                      root: {
                        lineHeight: 1.5,
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        maxWidth: shortenLongTitles ? maxTitleLength : 'unset'
                      }
                    }}
                    title={n.title}
                    to={`${baseStoreUrl}${n?.path}`}
                  >
                    {n.title}
                  </Anchor>
                ))}
              </Breadcrumbs>
            </ScrollArea>
          ) : (
            <AppStack
              style={{
                maxWidth:
                  config.limitWidth === 'true'
                    ? config.maxContainerWidth
                      ? Math.max(config.maxContainerWidth * 1, 300)
                      : 400
                    : '100%'
              }}
            >
              <Breadcrumbs
                separator={
                  config.separator === 'custom'
                    ? config.customSeparator || '/'
                    : config.separator
                }
              >
                {breadcrumbsData.map((n) => (
                  <Anchor
                    key={n.title + n.path}
                    component={Link}
                    onClick={onNavigate}
                    styles={{
                      root: {
                        lineHeight: 1.5,
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        maxWidth: shortenLongTitles ? maxTitleLength : 'unset'
                      }
                    }}
                    title={n.title}
                    to={`${baseStoreUrl}${n?.path}`}
                  >
                    {n.title}
                  </Anchor>
                ))}
              </Breadcrumbs>
            </AppStack>
          )}
        </AppStack>
      </WsSectionContainer>
    )
  );
};

WsBreadcrumbs.propTypes = {
  baseStoreUrl: PropTypes.string,
  blocks: PropTypes.array,
  colorSchemes: PropTypes.array,
  config: PropTypes.object,
  ecomStoreTheme: PropTypes.object,
  mediaQueries: PropTypes.object,
  onNavigate: PropTypes.func,
  pathname: PropTypes.string,
  resourceNavigation: PropTypes.array,
  themeConfig: PropTypes.object
};

export default WsBreadcrumbs;
